import Fetch from './index'

export const getPipedriveIntegration = async (assistantID) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/assistant/' + assistantID + '/pipedrive')
}

export const createPipedriveIntegration = async (assistantID, body) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/assistant/' + assistantID + '/pipedrive/', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const deletePipedriveIntegration = async (assistantID, id) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/assistant/' + assistantID + '/pipedrive/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const updatePipedriveIntegration = async (assistantID, id, body) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/assistant/' + assistantID + '/pipedrive/' + id, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
